"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.style.list': 'Style Pisania',
    'route.style.create': 'Dodaj Styl Pisania',
    'route.style.edit': 'Edytuj Styl Pisania',
    'route.style.preview': 'Podgląd Stylu',
};
